import type { IObjectSchema } from '@ksyos/koi/dist/koi';
import { Koi } from '@ksyos/koi';
import type { IGeneralPractitioner } from '@common/interfaces';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';

export type TypedGeneralPractitionerSchema = TypedSchema<IGeneralPractitioner>;

export function generalPractitionerSchema(allowNull?: boolean): TypedGeneralPractitionerSchema {
    const requiredIdSchema = Koi.string().uuid();

    return {
        organizationId: allowNull ? requiredIdSchema.allow(null) : requiredIdSchema,
        practitionerId: Koi.when('organizationId', {
            is: null,
            otherwise: requiredIdSchema,
            then: Koi.valid(null),
        }),
    };
}

export function getGeneralPractitionerSchema(allowNull?: boolean): IObjectSchema {
    return Koi.object(generalPractitionerSchema(allowNull));
}
